import { forwardRef } from 'react'
import './controls.css'
const Button = forwardRef(function Button({ as: Tag = 'button', variant = 'secondary', size = 'md', className = '', ...props }, ref) {
    return <Tag {...props} ref={ref} className={['uiButton', 'uiButton--' + variant, 'uiButton--' + size, className].filter(Boolean).join(' ')} />
})
export default Button
